import { MuiTheme, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = (props?: { showDrawer: boolean }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      usersHeading: {
        padding: '24px 40px',
        justifyContent: 'space-between',
        background: 'transparent',
        display: 'flex',
        height: '100px',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          flexDirection: 'row',
          gap: '20px'
        },
        [theme.breakpoints.only('sm')]: {
          padding: '18px 20px 18px 20px'
        },
        [theme.breakpoints.only('xs')]: {
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '18px 0px 18px 0px',
          height: '100%'
        },
        [theme.breakpoints.down('sm')]: {
          height: '100px'
        }
      },
      usersText: {
        lineHeight: '1',
        fontSize: '40px',
        letterSpacing: 'normal',
        fontWeight: 600,
        [theme.breakpoints.down('sm')]: {
          fontSize: '36px'
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: '32px'
        },
        [theme.breakpoints.only('md')]: {
          fontSize: '36px'
        }
      },
      userAddNewButton: {
        width: '175px',
        [theme.breakpoints.down('xs')]: {
          width: '175px',
          height: '41px'
        },
        [theme.breakpoints.only('md')]: {
          width: '175px',
          height: '45px'
        }
      },
      usersTableOuterBox: {
        flex: 'none',
        background: 'transparent',
        padding: '0px 40px',
        [theme.breakpoints.down('sm')]: {
          padding: '5px 20px 20px'
        }
      },
      usersTableContainer: {
        height: '700px',
        [theme.breakpoints.down('sm')]: {
          height: '790px'
        }
      },
      usersHeadersUsertype: {
        paddingLeft: '24px',
        lineHeight: '1.13',
        fontSize: '16px',
        fontWeight: 600
      },
      usersTableHeaders: {
        lineHeight: '1.13',
        fontSize: '16px',
        fontWeight: 600
      },
      usersTableRows: {
        height: '70px',
        '&$selected': {
          borderWidth: 0,
          borderLeftWidth: 20,
          borderColor: 'black',
          borderStyle: 'solid',
          backgroundColor: 'white'
        },
        '&$selected:hover': {
          backgroundColor: 'white'
        }
      },
      selected: {},
      userRoleRow: {
        paddingLeft: '24px !important'
      },
      footer: {
        width: '100%',
        overflow: 'hidden',
        padding: '0px 40px',
        margin: 0
      },
      total: {
        float: 'right',
        fontSize: '20px',
        padding: '10px',
        fontWeight: 900,
        margin: 0
      },
      body: {
        overflow: props && props.showDrawer ? 'hidden' : 'auto'
      }
    })
  );
